module.exports = __webpack_public_path__ + "img/blackre_bgm.11267e7b.png";